import { useEffect, useState } from 'react';

/**
 * Animate a number from 0 up to `target` over `durationMs` with an ease-out
 * curve. Respects `prefers-reduced-motion` and an `enabled` flag (both jump
 * straight to the target). Ported from fresh-dashboard.
 */
export function useCountUp(target, durationMs = 800, enabled = true) {
	const [value, setValue] = useState(enabled ? 0 : target);

	useEffect(() => {
		if (!enabled) {
			setValue(target);
			return undefined;
		}
		if (typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) {
			setValue(target);
			return undefined;
		}
		let raf = 0;
		const start = performance.now();
		const tick = (now) => {
			const t = Math.min(1, (now - start) / durationMs);
			const eased = 1 - Math.pow(1 - t, 3);
			setValue(Math.round(target * eased));
			if (t < 1) raf = requestAnimationFrame(tick);
		};
		raf = requestAnimationFrame(tick);
		return () => cancelAnimationFrame(raf);
	}, [target, durationMs, enabled]);

	return value;
}
